<template>
    <div class="modal-panel">
        <div class="overlay" @click="close"></div>

        <div class="menu">
            <div class="position-relative">
                <div class="d-flex terms-panel">
                    <div class="d-flex terms-header">
                        <div class="terms-header-title">
                            Terms of Use
                        </div>
                        <span class="d-flex terms-header-button pointer" @click="close">
                            <span class="material-symbols-outlined material-symbols-outlined-400 close-icon">
                                close
                            </span>
                            Close
                        </span>
                    </div>
                    <div class="d-flex flex-column terms-content">
                        <div class="d-flex flex-column terms-content-block">
                            <div class="terms-content-block-title">Fair Use and Copyright</div>
                            <div class="terms-content-block-text">
                                <p>Global Legal Guides ApS own the website www.mergerfilers.com (the Website) and the content of the Website is protected by copyright and trademark laws.</p>
                                <p>As a user of the Website you accept these Terms of Use.</p>
                                <p>You are entitled to use the information and functionalities made available on the Website and to copy and print the content of reports and searches made available by the Website for your own use and as a part of presentations to specific clients, provided you name the Website as source and that neither you nor your client shall be entitled to publish or otherwise share or distribute such content.</p>
                                <p>Furthermore, you can cite from any articles available on the Website in accordance with standard citation rules (please state title of article, author, date and “Mergerfilers.com”).</p>
                                <p>All rights not expressly granted are reserved by Global Legal Guides ApS.</p>
                            </div>
                        </div>
                        <div class="d-flex flex-column terms-content-block">
                            <div class="terms-content-block-title">Cookies and log data</div>
                            <div class="terms-content-block-text">
                                <p>Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive.</p>
                                <p>We collect information that your browser sends whenever you visit the Website ("Log Data"). This Log Data may include information such as your computer's IP address, browser type, browser version, the pages of the Website that you visit, the time and date of your visit, the time spent on those pages and other statistics. In addition, we may use third party services such as Google Analytics that collect, monitor and analyze traffic on the Website.</p>
                                <p>We use cookies and Log Data for providing and improving the Website and associated services.</p>
                                <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of the Website.</p>
                            </div>
                        </div>
                        <div class="d-flex flex-column terms-content-block">
                            <div class="terms-content-block-title">Personal data</div>
                            <div class="terms-content-block-text">
                                <p>To subscribe to our free e-mail updates we ask you to provide certain information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name, place of work, e-mail address and phone number.</p>
                                <p>We may use your personal information to contact you with newsletters and other information regarding the Website and services provided by Global Legal Guides ApS.</p>
                                <p>We will not share your personal data with any third parties except when required by law or when necessary to operate the Website and associated services.</p>
                                <p>If you unsubscribe to our up-date e-mails, we will automatically delete your personal data.</p>
                            </div>
                        </div>

                        <div class="d-flex flex-column terms-content-block">
                            <div class="terms-content-block-title">No liability clause</div>
                            <div class="terms-content-block-text">
                                <p>Global Legal Guides ApS, the editors and national experts strive to always provide the highest possible quality of up to date legal information. However, the information on the Website is general and cannot replace obtaining legal advice from relevant local experts. As a user you understand and agree that the Website and all content provided on the Website is provided without liability of any kind, including liability for accuracy of information; lack or interruption of access to a website; computer viruses and services obtained from third parties such as the editors and national experts who have provided content for the Website.</p>
                                <p>Please use our feedback function if you find any inaccuracies or other problems related to the Website.</p>
                            </div>
                        </div>
                        <div class="d-flex flex-column terms-content-block">
                            <div class="terms-content-block-title">Changes</div>
                            <div class="terms-content-block-text">
                                <p>Global Legal Guides ApS reserves the right to change the Website and these Terms of Use without prior notice.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

import {useMainStore} from "@/stores/mainStore";

const mainStore = useMainStore();

function close() {
    // console.log('calling close terms')
    mainStore.showTerms(false)
}

</script>

<style scoped lang="scss">
.modal-panel {
    position: absolute;
    top: 0;
}
.terms-panel {
    width: 90vw;
    max-height: 80vh;
    flex-direction: column;
    background: rgba(244, 247, 255, 1);
    border-radius: 12px;
    padding-bottom: 36px;
    gap: 36px;
    @media (min-width: $max-xl-screen) {
        border-radius: 16px;
        padding-bottom: 48px;
        gap: 48px;
    }
    @media (max-width: $max-md-screen) {
        border-radius: 9px;
        padding-bottom: 24px;
        gap: 24px;
    }
    @media (max-width: $max-sm-screen) {
        border-radius: 3.41px;
        padding-bottom: 16px;
        gap: 18px;
    }
}

.terms-header {
    width: 100%;
    justify-content: space-between;
    padding: 24px 36px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background: radial-gradient(102.04% 337.36% at 0% 0%, #DD6E1F 34.45%, #D74D46 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
    box-shadow: 0 4px 4px 0 rgba(0, 6, 122, 0.25);
    @media (min-width: $max-xl-screen) {
        padding: 32px 48px;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        box-shadow: 0px 5.33px 5.33px 0px rgba(0, 6, 122, 0.25);
    }
    @media (max-width: $max-md-screen) {
        padding: 24px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        box-shadow: 0px 2.19px 2.19px 0px rgba(0, 6, 122, 0.25);
    }
    @media (max-width: $max-sm-screen) {
        padding: 12px;
        border-top-left-radius: 3.41px;
        border-top-right-radius: 3.41px;
        box-shadow: 0px 1.1px 1.1px 0px rgba(0, 6, 122, 0.25);
    }
}
.terms-header-title {
    font-family: Raleway;
    font-weight: 600;
    font-size: 30px;
    line-height: 100%;
    letter-spacing: 0;
    color: rgba(235, 243, 255, 1);
    @media (min-width: $max-xl-screen) {
        font-size: 40px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 32px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 16px;
    }
}
.terms-header-button {
    border-radius: 20px;
    gap: 5px;
    align-items: center;

    font-family: Raleway;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
    color: rgba(235, 243, 255, 1);
    @media (min-width: $max-xl-screen) {
        gap: 6.67px;
        font-size: 21.33px;
    }
    @media (max-width: $max-md-screen) {
        gap: 8px;
        font-size: 18px;
    }
    @media (max-width: $max-sm-screen) {
        gap: 4px;
        font-size: 10px;
    }
}

.close-icon {
    font-size: 24px;
    color: rgba(235, 243, 255, 1);
    @media (min-width: $max-xl-screen) {
        font-size: 32px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 25.14px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 12.57px;
    }
}

.terms-content {
    gap: 36px;
    max-height: 100%;
    overflow-y: auto;
    @media (min-width: $max-xl-screen) {
        gap: 48px;
    }
    @media (max-width: $max-md-screen) {
        gap: 24px;
    }
    @media (max-width: $max-sm-screen) {
        gap: 18px;
    }
}

.terms-content-block {
    width: 100%;
    gap: 16px;
    padding-right: 32px;
    padding-left: 32px;
    @media (min-width: $max-xl-screen) {
        gap: 21.33px;
        padding-right: 42.67px;
        padding-left: 42.67px;
    }
    @media (max-width: $max-md-screen) {
        gap: 12px;
        padding-right: 24px;
        padding-left: 24px;
    }
    @media (max-width: $max-sm-screen) {
        gap: 12px;
        padding-right: 16px;
        padding-left: 16px;
    }
}
.terms-content-block-title {
    font-family: Raleway;
    font-weight: 700;
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0;

    /* Gradient as background */
    background: radial-gradient(102.04% 337.36% at 0% 0%, #DD6E1F 34.45%, #D74D46 100%);

    /* Make text show the background */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent; /* hides the text color itself */

    /* Optional for non-webkit browsers */
    background-clip: text;
    color: transparent;
    @media (min-width: $max-xl-screen) {
        font-size: 32px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 18px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 14px;
    }
}
p {
    margin-bottom: 10px;
    @media (min-width: $max-xl-screen) {
        margin-bottom: 13.33px;
    }
    @media (max-width: $max-md-screen) {
        margin-bottom: 5px;
    }
}
.terms-content-block-text {
    font-family: Raleway;
    font-weight: 400;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0;
    color: rgba(24, 24, 24, 1);
    @media (min-width: $max-xl-screen) {
        font-size: 24px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 12px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 12px;
    }
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6); /* 60% dark overlay */
    z-index: 1; /* must be below the menu but above page content */
}


.menu {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
